import { checkIsActionBarCode, checkIsRestartCode } from '../../../../utils/sharedValidationUtils';

export const getFirstBarcode = (item, defaultValue = ' ') => {
  return item?.barcodes?.length > 0 ? item.barcodes[0].barcode : defaultValue;
};

export { checkIsActionBarCode, checkIsRestartCode };

export const checkIsMultiBoxNavigation = (barcodeInput, generalSettings) => {
  if (!generalSettings?.multi_box_shipments) {
    return { isNavigation: false, direction: null };
  }

  if (barcodeInput === 'BOXPREV') {
    return { isNavigation: true, direction: 'prev' };
  }

  if (barcodeInput === 'BOXNEXT') {
    return { isNavigation: true, direction: 'next' };
  }

  return { isNavigation: false, direction: null };
};

export const checkIsNotFulfilledBarcode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.not_fulfilled) {
    return false;
  }
  return barcodeInput === scanPackSettings?.not_fulfilled_barcode;
};

export const checkIsNoteFromPackerCode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.note_from_packer_code_enabled) {
    return false;
  }
  return barcodeInput === scanPackSettings?.note_from_packer_code;
};

export const checkIsServiceIssueCode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.service_issue_code_enabled) {
    return false;
  }
  return barcodeInput === scanPackSettings?.service_issue_code;
};

export const checkIsClickScanBarcode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.click_scan) {
    return false;
  }
  return barcodeInput === scanPackSettings?.click_scan_barcode;
};

export const checkIsPassScanBarcode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.pass_scan) {
    return false;
  }
  return barcodeInput === scanPackSettings?.pass_scan_barcode;
};

export const checkIsAddNextBarcode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.add_next) {
    return false;
  }
  return barcodeInput === scanPackSettings?.add_next_barcode;
};

export const checkIsRemoveBarcode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.remove_enabled) {
    return false;
  }
  return barcodeInput === scanPackSettings?.remove_barcode;
};

export const checkIsPartialBarcode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.partial) {
    return false;
  }
  return barcodeInput === scanPackSettings?.partial_barcode;
};

export const checkIsTypeScanCode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.type_scan_code_enabled) {
    return false;
  }
  return barcodeInput === scanPackSettings?.type_scan_code;
};

export const checkIsScannedBarcode = (barcodeInput, scanPackSettings) => {
  if (!scanPackSettings?.scanned) {
    return false;
  }
  return barcodeInput === scanPackSettings?.scanned_barcode;
};

export const usesLowercaseMatching = (scanPackSettings, generalSettings) => {
  const sequence = scanPackSettings?.scanning_sequence;
  return sequence === 'any_sequence' || (sequence === 'kit_packing_mode' && !generalSettings?.master_switch);
};

const matchesSkipCode = (barcodeInput, scanPackSettings, lowercase) => {
  const skipCode = scanPackSettings?.skip_code;
  if (typeof skipCode !== 'string' || typeof barcodeInput !== 'string') return false;
  return lowercase ? barcodeInput.toLowerCase() === skipCode.toLowerCase() : barcodeInput === skipCode;
};

export const checkIsSkipBarcode = (barcodeInput, scanPackSettings, lowercase = false) => {
  if (!scanPackSettings?.skip_code_enabled) return false;
  return matchesSkipCode(barcodeInput, scanPackSettings, lowercase);
};

export const checkIsDisabledSkipBarcode = (barcodeInput, scanPackSettings, lowercase = false) => {
  if (scanPackSettings?.skip_code_enabled) return false;
  return matchesSkipCode(barcodeInput, scanPackSettings, lowercase);
};

export const getActionBarcodeType = (barcodeInput, scanPackSettings, generalSettings) => {
  if (checkIsRestartCode(barcodeInput, scanPackSettings)) {
    return 'RESTART';
  }

  const multiBoxNav = checkIsMultiBoxNavigation(barcodeInput, generalSettings);
  if (multiBoxNav.isNavigation) {
    return multiBoxNav.direction === 'prev' ? 'BOXPREV' : 'BOXNEXT';
  }

  if (checkIsNotFulfilledBarcode(barcodeInput, scanPackSettings)) {
    return 'NOT_FULFILLED';
  }

  if (checkIsNoteFromPackerCode(barcodeInput, scanPackSettings)) {
    return 'NOTE_FROM_PACKER';
  }

  if (checkIsServiceIssueCode(barcodeInput, scanPackSettings)) {
    return 'SERVICE_ISSUE';
  }

  if (checkIsClickScanBarcode(barcodeInput, scanPackSettings)) {
    return 'CLICK_SCAN';
  }

  if (checkIsPassScanBarcode(barcodeInput, scanPackSettings)) {
    return 'PASS_SCAN';
  }

  if (checkIsAddNextBarcode(barcodeInput, scanPackSettings)) {
    return 'ADD_NEXT';
  }

  if (checkIsRemoveBarcode(barcodeInput, scanPackSettings)) {
    return 'REMOVE';
  }

  if (checkIsPartialBarcode(barcodeInput, scanPackSettings)) {
    return 'PARTIAL';
  }

  if (checkIsScannedBarcode(barcodeInput, scanPackSettings)) {
    return 'SCANNED';
  }

  if (checkIsSkipBarcode(barcodeInput, scanPackSettings, usesLowercaseMatching(scanPackSettings, generalSettings))) {
    return 'SKIP';
  }

  return null;
};
